import { createSlice } from '@reduxjs/toolkit';
import { Card } from '../../models/Card';

interface PreviewState {
  isPreviewVisible: boolean;
  areCardsVisible: boolean;
  card: Card | null,
  cards: Card[],
}

const initialState: PreviewState = {
  isPreviewVisible: false,
  areCardsVisible: true,
  card: null,
  cards: [],
}

const previewSlice = createSlice({
  name: 'preview',
  initialState,
  reducers: {
    showPreview: ((state, data) => {
      state.isPreviewVisible = true;
      state.card = data.payload.card;
      state.cards = data.payload.cards;
    }),
    hidePreview: ((state) => {
      state.isPreviewVisible = false;
      state.card = null;
    }),
    toggleHandVisibility: ((state) => {
      state.areCardsVisible = !state.areCardsVisible;
    }),
  },
});

export const previewActions = previewSlice.actions;
export default previewSlice.reducer;